export const initialState = {
  loginData: {
    loading: false,
    error: '',
    data: null,
  },
  sendVerifyData: {
    error: '',
    data: null,
    loading: false,
    verifyItem: null,
  },
  confirmRecoveryPassword: {
    loading: false,
    error: '',
    patientIdAfterConfirmChangePassword: null,
  },
  changePassword: {
    loading: false,
    error: '',
  },
  patientLoginInfo: {},
  loading: {},
};
